<mat-card appearance="outlined">
  <mat-card-title *ngIf="title">{{ title }}</mat-card-title>
  <mat-card-content>
      <div [innerHTML]="message">{{ message }}</div>
  </mat-card-content>
  <mat-card-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-stroked-button color="primary" (click)="onClick()">OK</button>
  </mat-card-actions>
</mat-card>
